import React, { createContext, useContext, useState, useCallback } from "react";
import DonateModal from "./index";
import { ResourceTypes } from "../../constants/enums";

const DonateModalContext = createContext(null);

export const useDonateModal = () => {
  const ctx = useContext(DonateModalContext);
  if (!ctx) {
    throw new Error("useDonateModal must be used within DonateModalProvider");
  }
  return ctx;
};

export const DonateModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [resolvedType, setResolvedType] = useState(ResourceTypes.PLATFORM);
  const [id, setId] = useState(undefined);

  const openDonateModal = useCallback((type = ResourceTypes.PLATFORM, donationId) => {
    setResolvedType(type);
    setId(donationId);
    setIsOpen(true);
  }, []);

  const closeDonateModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <DonateModalContext.Provider
      value={{ openDonateModal, closeDonateModal, isOpen, resolvedType, id }}
    >
      {children}
      <DonateModal
        isOpen={isOpen}
        onClose={closeDonateModal}
        resolvedType={resolvedType}
        id={id}
      />
    </DonateModalContext.Provider>
  );
};
